import { render, staticRenderFns } from "./InputTextMailDialog.vue?vue&type=template&id=e0c5b2e4&scoped=true&"
import script from "./InputTextMailDialog.vue?vue&type=script&lang=js&"
export * from "./InputTextMailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0c5b2e4",
  null
  
)

export default component.exports